/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Supported_SitesInputs */



/**
* | output |
* | --- |
* | "Supported: vdb.im, vtesdecks.com, amaranth.vtes.co.nz" |
*
* @param {Deck_Upload_Supported_SitesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_supported_sites = /** @type {((inputs?: Deck_Upload_Supported_SitesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Supported_SitesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sites pris en charge : vdb.im, vtesdecks.com, amaranth.vtes.co.nz")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compatibles: vdb.im, vtesdecks.com, amaranth.vtes.co.nz")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Suportados: vdb.im, vtesdecks.com, amaranth.vtes.co.nz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Supportati: vdb.im, vtesdecks.com, amaranth.vtes.co.nz")
	return /** @type {LocalizedString} */ ("Supported: vdb.im, vtesdecks.com, amaranth.vtes.co.nz")
});